module.exports = __webpack_public_path__ + "img/sankaku_48_blue.a9ca1817.png";